import React, { ReactNode, useEffect, useState, JSX, useRef } from 'react';
import { ApiBookingPane, ApiBookingSearch } from '@ibe/api';
import BookingSearch from '../BookingSearch/BookingSearch';
import BookingList from '../BookingList/BookingList';
import LoadingOverlay from '../../UI/LoadingOverlay/LoadingOverlay';
import useManageBookingService from '../../../Hooks/useManageBookingService';

export interface BookingSearchModuleProps {
  onSearch: (params: Partial<ApiBookingSearch>) => void;
  searchParams?: ApiBookingSearch;
  handleBookingPaneClick?: (bookingId: string | undefined) => void;
  customBookingRecordRenderer?: (bookingPane: ApiBookingPane) => ReactNode;
  showLeadTravelName?: boolean;
}

const BookingSearchModule = (props: BookingSearchModuleProps): JSX.Element => {
  const manageBookingService = useManageBookingService();
  const oldSearchParams = useRef<ApiBookingSearch | undefined>(undefined);

  const {
    searchParams,
    onSearch,
    handleBookingPaneClick,
    customBookingRecordRenderer,
    showLeadTravelName
  } = props;

  const [bookingPanes, setBookingPanes] = useState<ApiBookingPane[] | undefined>([]);
  const [searched, setSearched] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const search = async () => {
      if (
        loading ||
        (oldSearchParams.current &&
          JSON.stringify(oldSearchParams.current) === JSON.stringify(searchParams))
      ) {
        return;
      }
      oldSearchParams.current = JSON.parse(JSON.stringify(searchParams));
      setLoading(true);
      try {
        const response = await manageBookingService.searchBookings(searchParams);
        setBookingPanes(response);
        setSearched(true);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setBookingPanes([]);
        console.error(error);
      }
    };
    search();
  }, [manageBookingService, searchParams]);

  return (
    <div>
      <LoadingOverlay isLoading={loading}>
        <BookingSearch onSearch={onSearch} searchData={searchParams} />
        {searched ? (
          <BookingList
            bookingList={bookingPanes}
            handleBookingPaneClick={handleBookingPaneClick}
            showLeadTravelName={showLeadTravelName}
            customBookingRecordRenderer={customBookingRecordRenderer}
          />
        ) : (
          <></>
        )}
      </LoadingOverlay>
    </div>
  );
};

export default BookingSearchModule;
